import { every, includes } from 'lodash';

import { JobType } from 'interfaces/job';

const batchParentJobTypes = [
  JobType.Inference,
  JobType.PostProcessingAndCalculateFeatures,
  JobType.MultiplexBlobSegmentation,
  JobType.MultiplexHistogram,
  JobType.MultiplexNormalization,
  JobType.MultiplexPeakDetection,
  JobType.CellSegmentation,
  JobType.CellQuantification,
];

export const usesBatchParentJobs = (jobType: JobType | JobType[]): boolean => {
  const jobTypes = Array.isArray(jobType) ? jobType : [jobType];
  return every(jobTypes, (currentJobType) => includes(batchParentJobTypes, currentJobType));
};
